import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import {
  findArmedAutoSyncForEvent, findArmedAutoSyncForToken, stopAutoSyncRemote,
} from '../../utils/localFolderSync/autoSyncRegistry';

// Renders nothing unless this device still has a folder auto-sync armed for
// an event/upload-link whose own page just failed to load (event deleted,
// upload link revoked) - EventPage.js/UploadLinkPage.js's error branches
// return before ever mounting useLocalAutoSync's own "Stop auto-sync"/"Stop
// watching" control, which would otherwise strand the background watcher
// (the live JS poll, and on native FolderSyncForegroundService/WorkManager)
// with no in-app way to turn it off - see autoSyncRegistry.js's
// findArmedAutoSyncForEvent/findArmedAutoSyncForToken for why the two
// callers below look it up differently.
//
// Pass exactly one of `eventId` (EventPage) or `token` (UploadLinkPage).
export default function StrandedAutoSyncStopButton({ eventId, token }) {
  const [record, setRecord] = useState(null);
  const [stopping, setStopping] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const lookup = eventId ? findArmedAutoSyncForEvent(eventId) : findArmedAutoSyncForToken(token);
    lookup.then((r) => { if (!cancelled) setRecord(r); }).catch(() => {});
    return () => { cancelled = true; };
  }, [eventId, token]);

  if (!record) return null;

  return (
    <Button
      variant="outlined"
      color="inherit"
      disabled={stopping}
      startIcon={stopping ? <CircularProgress size={16} color="inherit" /> : null}
      onClick={async () => {
        setStopping(true);
        await stopAutoSyncRemote(record.eventId, record.storageKey).catch(() => {});
        setStopping(false);
        setRecord(null);
      }}
      sx={{ textTransform: 'none', mt: 2 }}
    >
      {stopping ? 'Stopping…' : `Stop watching "${record.folderName}"`}
    </Button>
  );
}
